<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="tree" href="/tabs/tree">
          <ion-icon :icon="albumsOutline" />
          <ion-label>Containers</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="list_all" href="/tabs/list_all">
          <ion-icon :icon="searchOutline" />
          <ion-label>Search</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="scan" href="/tabs/scan">
          <ion-icon :icon="barcodeOutline" />
          <ion-label>Scan</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="schemas" href="/tabs/schemas">
          <ion-icon :icon="libraryOutline" />
          <ion-label>Schemas</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="settings" href="/tabs/settings">
          <ion-icon :icon="settingsIcon" />
          <ion-label>Settings</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup lang="ts">
import { defineComponent, onMounted } from "vue";
import {
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonLabel,
  IonIcon,
  IonPage,
  IonRouterOutlet,
} from "@ionic/vue";
import {
  albumsOutline,
  searchOutline,
  barcodeOutline,
  cogOutline,
  libraryOutline,
  settingsOutline,
} from "ionicons/icons";
import { useApiStore } from "@/stores/api";

defineComponent({
  name: "TabsPage",
});

// https://vuejs.org/api/composition-api-lifecycle.html#onmounted
onMounted(() => {
  const api = useApiStore();
  // https://stackoverflow.com/a/71294744/3423324#how-to-fetch-data-from-api-in-vuex
  // https://github.com/paroi-tech/direct-vuex/tree/af0868d63f9893ff34fa722c94ec7a402edbeb59#use-typed-wrappers-from-outside-the-store
  // noinspection TypeScriptValidateJSTypes
  api.fetchObjects();
});

const isIos = () => {
  const win = window as any;
  return win && win.Ionic && win.Ionic.mode === "ios";
};

const settingsIcon = isIos() ? cogOutline : settingsOutline;
</script>
